import { CONTACT_TYPE_ID, COMPANY_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { AvatarLookup } from '../../../helpers/avatarHelpers';
import { getObjectTypeIconComponent } from 'customer-data-objects-ui-components/objects/getObjectTypeIconComponent';
import { CustomObjectIcon } from 'foundations-assets/icons/components/CustomObjectIcon';
import { jsx as _jsx } from "react/jsx-runtime";
function AssociationChicletAvatarOrIcon({
  association
}) {
  const shouldUseAvatar = association.objectTypeId === CONTACT_TYPE_ID || association.objectTypeId === COMPANY_TYPE_ID;
  if (shouldUseAvatar) {
    return /*#__PURE__*/_jsx(AvatarLookup, {
      objectId: association.objectId,
      objectTypeId: association.objectTypeId,
      size: "xs"
    });
  }
  const IconComponent = getObjectTypeIconComponent(association.objectTypeId, {
    DefaultIconComponent: CustomObjectIcon
  });
  if (!IconComponent) {
    return null;
  }
  return /*#__PURE__*/_jsx(IconComponent, {
    size: "600"
  });
}
export default AssociationChicletAvatarOrIcon;